import { jsx as _jsx } from "react/jsx-runtime";
import { AppText, styled } from '@streem/ui-react';
export const ListItem = props => _jsx(AppText, { as: "li", children: props.children });
export const List = styled.ul `
    list-style: disc;
    padding-left: 25px;
`;
export const BlueLink = styled.a `
    text-decoration: none;
    color: ${props => props.theme.colors.azure};
    font-weight: 600;
`;
//# sourceMappingURL=troubleshooting_list_items.js.map